"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
var _Detail = _interopRequireDefault(require("./Detail"));
var _Progress = _interopRequireDefault(require("@/components/Progress"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    Detail: _Detail.default,
    Progress: _Progress.default
  },
  props: {
    urlModule: {
      type: String,
      default: ''
    },
    pageTitle: {
      type: String,
      default: ''
    },
    pageName: {
      type: String,
      default: ''
    },
    queryDomData: {
      type: Object,
      require: true,
      default: function _default() {
        return {};
      }
    },
    queryData: {
      type: Object,
      require: true,
      default: function _default() {
        return {};
      }
    },
    tableButtons: {
      type: Object,
      require: true,
      default: function _default() {
        return {};
      }
    },
    tableDom: {
      type: Object,
      require: true,
      default: function _default() {
        return {};
      }
    },
    tableDetail: {
      type: Function,
      default: function _default() {}
    },
    // 导入结果不展示字段
    disabledKeyList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 列表不展示字段
    disabledKeyList2: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    listApi: {
      type: Object,
      require: true,
      default: function _default() {
        return {};
      }
    },
    apiModule: {
      type: String,
      require: true,
      default: 'kpiSet'
    },
    errorResult: {
      type: Object,
      require: true,
      default: function _default() {
        return {
          apiName: 'exportErrorFileResult'
        };
      }
    },
    hasProvince: {
      type: String,
      default: '',
      enum: ['1', '2'] // 目前只支持到市，不到区
    }
  },
  data: function data() {
    return {
      searchVal: (0, _objectSpread2.default)({}, this.queryData),
      /** table group */
      listLoading: false,
      currPage: 1,
      limit: 10,
      total: 0,
      list: [],
      form: {
        file: null
      },
      sourceApi: null,
      // api timer
      lookupList: {},
      isError: '',
      isShowModel: false,
      isShowProgress: false,
      excelBatchId: '',
      fileImportProcessUniqueCode: '',
      showClose: false,
      showResult: false,
      confirmText: null,
      isLoading: false,
      regionOptions: [],
      cityOptions: [],
      districtOptions: []
    };
  },
  computed: {
    queryDomDataKeys: function queryDomDataKeys() {
      return Object.keys(this.queryDomData);
    },
    tableButtonsKeys: function tableButtonsKeys() {
      return Object.keys(this.tableButtons);
    },
    tableDomKeys: function tableDomKeys() {
      return Object.keys(this.tableDom);
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  created: function created() {
    // 如果用到了省市区数据，需要获取options数据
    if (Number(this.hasProvince) > 0) {
      if (Number(this.hasProvince) < 3) {
        this.getRegionOptions();
      } else {
        this.$message.error(this.$t('common.paramError'));
      }
    }
  },
  mounted: function mounted() {
    // 记录初始query,默认只有一层
    this.resetQuery = (0, _objectSpread2.default)({}, this.queryData);
    // 查询列表
    this.searchData();
  },
  methods: {
    getRegionOptions: function getRegionOptions() {
      var _this = this;
      var regionOptions = this.$store.getters.getRegionData("level_".concat(this.hasProvince));
      if (Array.isArray(regionOptions) && regionOptions.length) {
        this.regionOptions = regionOptions;
        return;
      }
      this.$api.common.getRegionList(this.hasProvince).then(function (res) {
        if (res.success) {
          _this.regionOptions = res.data || [];
          _this.$store.dispatch('baseData/saveRegionDataByLevel', {
            key: "level_".concat(_this.hasProvince),
            regionData: res.data || []
          });
        }
      });
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    fetchData: function fetchData() {
      var _this2 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      this.listLoading = true;
      var apiModule = this.listApi.apiModule || this.apiModule;
      var promiseFn = this.$api[apiModule]['getKpiList'];
      promiseFn(this.listApi.apiUrl, param, this.sourceApi.token, this.urlModule).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data.items;
        _this2.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    resetData: function resetData() {
      this.searchVal = (0, _objectSpread2.default)({}, this.resetQuery);
      this.fetchData();
    },
    handleError: function handleError() {
      this.confirmText = this.$t('common.checkResult');
    },
    handleClickConfirm: function handleClickConfirm() {
      if (this.confirmText === this.$t('common.checkResult')) {
        this.isShowProgress = false;
        this.isShowModel = true;
      } else {
        this.isShowProgress = false;
      }
    },
    handleEnd: function handleEnd() {
      this.searchData();
    },
    downloadResultExcel: function downloadResultExcel() {
      var _this3 = this;
      var fileName = "".concat(this.tableButtons['export']['fileName']).concat((0, _index.parseTime)(new Date().getTime()), "-").concat(this.$t('common.errorInfo'), ".xlsx");
      this.isLoading = true;
      var apiModule = this.listApi.apiModule || this.apiModule;
      var promiseFn = this.$api[apiModule][this.errorResult['apiName']];
      promiseFn(this.excelBatchId, this.urlModule).then(function (res) {
        _this3.isLoading = false;
        (0, _index.downloadFileExcel)(fileName, res.data, true);
      }).catch(function () {
        _this3.isLoading = false;
      });
    },
    downloadExcel: function downloadExcel() {
      var _this4 = this;
      if (this.isLoading) return;
      var param = (0, _objectSpread2.default)({}, this.searchVal);
      this.isLoading = true;
      var apiModule = this.tableButtons['export']['apiModule'] || this.apiModule;
      var promiseFn = this.$api[apiModule]['exportKpiFile'];
      var fileName = this.tableButtons['export']['fileName'];
      promiseFn(this.tableButtons['export']['apiUrl'], param, this.urlModule).then(function (res) {
        _this4.isLoading = false;
        (0, _index.downloadFileExcel)(fileName, res.data);
      }).catch(function () {
        _this4.isLoading = false;
      });
    },
    uploadData: function uploadData(file) {
      var _this5 = this;
      // 数据状态初始化
      this.confirmText = this.$t('common.confirm');
      var rawFile = file.raw;
      if (!rawFile) return;
      if (rawFile.size > 100 * 1024 * 1024) {
        this.$message.error('The file size cannot exceed 100M');
        return;
      }
      this.isLoading = true;
      var param = new FormData();
      param.append('file', rawFile);
      var apiModule = this.tableButtons['import']['apiModule'] || this.apiModule;
      var promiseFn = this.$api[apiModule]['importKpiFile'];
      promiseFn(this.tableButtons['import']['apiUrl'], param, this.urlModule).then(function (res) {
        _this5.isLoading = false;
        _this5.isShowProgress = true;
        _this5.excelBatchId = res.data.excelBatchId;
        _this5.fileImportProcessUniqueCode = res.data.redisKey;
        _this5.showClose = true;
        _this5.$nextTick(function () {
          _this5.$refs['progress'].start();
        });
      }).catch(function (res) {
        _this5.isLoading = false;
      });
    },
    paddingNum: function paddingNum(inputParam) {
      // 如果是百分比，需要加工一下
      var index = (inputParam + '').indexOf('%');
      if (index > -1) {
        var str = inputParam.substring(0, index);
        return (0, _index.paddingNum)(str) + '%';
      } else {
        return (0, _index.paddingNum)(inputParam);
      }
    },
    pcdClearEvent: function pcdClearEvent(keyList, queryKey) {
      var _this6 = this;
      console.log(keyList);
      // 清空值
      if (Array.isArray(keyList)) {
        keyList.forEach(function (k) {
          _this6.searchVal[k] = '';
        });
      }
    },
    pcdChangeEvent: function pcdChangeEvent(value, keyList, queryKey) {
      console.log(keyList);
      var rtlRegionList = [];
      var rtlCityList = [];
      var rtlDistrictList = [];
      while (value.some(function (item) {
        console.log(item);
        if (item.length === 3) {
          if (rtlRegionList.indexOf(item[0]) === -1) {
            rtlRegionList.push(item[0]);
          }
          if (rtlCityList.indexOf(item[1]) === -1) {
            rtlCityList.push(item[1]);
          }
          if (rtlDistrictList.indexOf(item[2]) === -1) {
            rtlDistrictList.push(item[2]);
          }
        }
        // eslint-disable-next-line no-empty
      })) {}
      this.searchVal.regionCode = rtlRegionList;
      this.searchVal.cityCode = rtlCityList;
      this.searchVal.districtCode = rtlDistrictList;
      console.log('=====val=====', value);
      // this.searchVal.rtlDistrictList = value
    },
    provinceChangeEvent: function provinceChangeEvent(value, contactQueryKey, queryKey) {
      if (!contactQueryKey) {
        return;
      }
      var targetCity = this.regionOptions.find(function (t) {
        return t.value === value;
      });
      if (this.queryDomData[queryKey]['needLabelKey'] && value) {
        this.searchVal[this.queryDomData[queryKey]['valueKey']] = targetCity.label;
      }
      if (targetCity) {
        this.cityOptions = (0, _toConsumableArray2.default)(targetCity.children);
      }
    },
    provinceClearEvent: function provinceClearEvent(contactQueryKey, queryKey) {
      var _this7 = this;
      // 数组或字符串
      if (!contactQueryKey) {
        return;
      }
      // 清空值
      if (Array.isArray(contactQueryKey)) {
        contactQueryKey.forEach(function (k) {
          _this7.searchVal[k] = '';
        });
      } else {
        this.searchVal[contactQueryKey] = '';
        this.searchVal['city'] = '';
      }
      console.log('---contactQueryKey----', contactQueryKey);
      // 清空下拉选项(目前只到市)
      if (this.cityOptions.length) {
        this.cityOptions = [];
      }
    },
    cityChangeEvent: function cityChangeEvent(value, contactQueryKey, queryKey) {
      if (!contactQueryKey) {
        return;
      }
      var targetDistrict = this.cityOptions.find(function (t) {
        return t.value === value;
      });
      if (this.queryDomData[queryKey]['needLabelKey'] && value) {
        console.log('===needLabelKey====', this.queryDomData[queryKey]['needLabelKey']);
        this.searchVal[this.queryDomData[queryKey]['valueKey']] = targetDistrict.label;
      }
      // if (targetDistrict) {
      //   this.districtOptions = [...targetDistrict.children];
      // }
    },
    cityClearEvent: function cityClearEvent(contactQueryKey) {
      if (!contactQueryKey) {
        return;
      }
      this.searchVal[contactQueryKey] = '';
      // 清空下拉选项(目前只到市)
      if (this.districtOptions.length) {
        this.districtOptions = [];
      }
    }
  }
};